<template>
  <v-container class="py-8">
    <v-row justify="center">
      <v-col cols="12" md="8" lg="6">
        <v-card class="mb-4" elevation="2">
          <v-card-title class="primary white--text pa-4">
            <v-icon color="white" class="mr-2">mdi-pencil-box-outline</v-icon>
            Comentário sobre a Avaliação
          </v-card-title>
          <v-card-text class="pa-4">
            <p class="body-2 grey--text text--darken-1 mb-4">
              Instituição: <strong>{{ param.pessoa && param.pessoa.instituicao }}</strong>
            </p>
            <v-textarea
              v-model="comentario"
              outlined
              label="Escreva seu comentário aqui"
              placeholder="Digite suas observações, sugestões ou críticas construtivas..."
              rows="8"
              counter
              maxlength="2000"
              no-resize
            />
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-btn color="grey darken-1" text @click="encerrar">
              <v-icon left>mdi-close-circle-outline</v-icon>
              Encerrar respostas
            </v-btn>
            <v-spacer />
            <v-btn color="success" :disabled="!comentario.trim() || salvando" :loading="salvando" @click="salvarComentario">
              <v-icon left>mdi-content-save</v-icon>
              Salvar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import ComentariosServices from '@/services/ava/Comentarios.services';
export default {
  name: 'ComentarioAvaliacao',
  data: () => ({
    comentario: '',
    salvando: false,
  }),
  computed: {
    ...mapGetters({ param: 'avaliacao/param' }),
  },
  methods: {
    ...mapMutations({ setPessoa: 'avaliacao/setPessoa' }),
    ...mapActions({ requestComentario: 'avaliacao/requestComentario' }),
    encerrar() {
      this.$store.commit('avaliacao/setSelecionado', null);
      this.setPessoa(null);
      this.$router.push({ name: 'initPage' });
    },
    async salvarComentario() {
      this.salvando = true;
      try {
        const payload = {
          id_questionario: this.param.Selecionado.id,
          id_instituicao: this.param.pessoa.id_instituicao,
          cpf: this.param.pessoa.cpf,
          comentario: this.comentario.trim(),
        };
        console.log(payload);
        await ComentariosServices.insert(payload);
        this.$toast.success('Comentário salvo com sucesso!');
      } catch {
        this.$toast.error('Erro ao salvar comentário.');
      } finally {
        this.salvando = false;
        this.encerrar();
      }
    },
  },
};
</script>
